var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrgActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2868_25058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.877 16.875H28.125C29.1504 16.875 30 17.7246 30 18.75V28.125C30 29.1504 29.1504 30 28.125 30H18.75C17.7246 30 16.875 29.1504 16.875 28.125V18.75C16.875 17.7246 17.7246 16.875 18.75 16.875H22.0605V15.7617H7.91016V16.875H11.25C12.2754 16.875 13.125 17.7246 13.125 18.75V28.125C13.125 29.1504 12.2754 30 11.25 30H1.875C0.849609 30 0 29.1504 0 28.125V18.75C0 17.7246 0.849609 16.875 1.875 16.875H6.09375V15.1172C6.09375 14.4727 6.91406 14.1504 7.64648 14.1504H14.0918V13.0957H10.0488C9.02344 13.0957 8.17383 12.2461 8.17383 11.2207V1.8457C8.17383 0.820312 9.02344 -0.0292969 10.0488 -0.0292969H19.4238C20.4492 -0.0292969 21.2988 0.820312 21.2988 1.8457V11.2207C21.2988 12.2461 20.4492 13.0957 19.4238 13.0957H15.9668V14.1797C18.3984 14.1797 19.8926 14.1504 22.3242 14.1504C23.0566 14.1504 23.877 14.4434 23.877 15.1172V16.875ZM28.125 18.75H18.75V28.125H28.125V18.75ZM19.4238 1.8457H10.0488V11.2207H19.4238V1.8457ZM11.25 18.75H1.875V28.125H11.25V18.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2868_25058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgActive);
export default __webpack_public_path__ + "static/media/org_active.7fb7caf7d55bb5cc3aac18200ddc7163.svg";
export { ForwardRef as ReactComponent };